import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import InAppMessage from "./in-app-message.js";
var HtmlMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(HtmlMessage, _InAppMessage);
  var _super = _createSuper(HtmlMessage);
  function HtmlMessage(i, o, d, e, r, t, s, v, n, u, a, c) {
    var _this;
    _classCallCheck(this, HtmlMessage);
    _this = _super.call(this, i, void 0, void 0, o, d, void 0, void 0, void 0, e = e || InAppMessage.DismissType.MANUAL, r, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, t, s, void 0, void 0, void 0, v, void 0, void 0, void 0, n, u, c, void 0, void 0), _this.messageFields = a, _this.messageFields = a;
    return _this;
  }
  _createClass(HtmlMessage, [{
    key: "Bo",
    value: function Bo() {
      return !1;
    }
  }, {
    key: "$t",
    value: function $t(i) {
      if (this.He === InAppMessage.Ke.Hr) {
        if (this.Co) return !1;
        this.Co = !0;
      }
      return this.ti.L(i), !0;
    }
  }, {
    key: "dt",
    value: function dt() {
      var i = _get(_getPrototypeOf(HtmlMessage.prototype), "dt", this).call(this, HtmlMessage.es);
      return i[InAppMessage.ss.Po] = this.messageFields, i;
    }
  }], [{
    key: "Xr",
    value: function Xr(i) {
      return new HtmlMessage(i[InAppMessage.ss.Vr], i[InAppMessage.ss.xs], i[InAppMessage.ss.Yr], i[InAppMessage.ss.sa], i[InAppMessage.ss.ta], i[InAppMessage.ss.fa], i[InAppMessage.ss.da], i[InAppMessage.ss.xa], i[InAppMessage.ss.wa], i[InAppMessage.ss.CSS], i[InAppMessage.ss.Po], i[InAppMessage.ss.ya]);
    }
  }]);
  return HtmlMessage;
}(InAppMessage);
export { HtmlMessage as default };
HtmlMessage.es = InAppMessage.Ke.Hr;